export const CloudSvg = ({ fill = "#253747" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0002 10.488L13.5357 14.0235L12.3572 15.202L10.8335 13.679V18.3332H9.16683V13.6773L7.64314 15.202L6.46463 14.0235L10.0002 10.488ZM10.0002 1.6665C12.9947 1.6665 15.4622 3.92285 15.7952 6.82813C17.7383 7.35945 19.1668 9.13784 19.1668 11.2498C19.1668 13.6405 17.3365 15.6037 15.0007 15.8145L15.0009 14.1368C16.414 13.9343 17.5002 12.7189 17.5002 11.2498C17.5002 9.639 16.1943 8.33317 14.5835 8.33317C14.4095 8.33317 14.2391 8.34842 14.0741 8.37817C14.1348 8.095 14.1668 7.80115 14.1668 7.49984C14.1668 5.19865 12.3013 3.33317 10.0002 3.33317C7.69898 3.33317 5.8335 5.19865 5.8335 7.49984C5.8335 7.80115 5.86548 8.095 5.92687 8.37759C5.76125 8.34842 5.59082 8.33317 5.41683 8.33317C3.806 8.33317 2.50016 9.639 2.50016 11.2498C2.50016 12.6668 3.5105 13.8477 4.85005 14.1115L5.0002 14.137L5.00049 15.8145C2.6643 15.6042 0.833496 13.6408 0.833496 11.2498C0.833496 9.13784 2.26203 7.35945 4.20556 6.82826C4.53817 3.92285 7.00567 1.6665 10.0002 1.6665Z"
        fill={fill}
      />
    </svg>
  );
};
